import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Header from './Header';
import HeaderJobseeker from './HeaderJobseeker';
import MessageList from './Messages';
import Footer from './Footer';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  chatbox: {
    backgroundColor: '#999',
    height: 'calc(100vh - 104px)',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 58px)',
    }
  }
}));

function renderHeader(props) {
  let rep = props.rep;
  if( rep ) {
    return (<Header profile={rep} actions={props.actions} />);
  } else
    if (props.peer.uuid) {
    return (<HeaderJobseeker profile={props.peer} actions={props.actions} />);
  }
}

function renderBlockedMessage(props) {
  return props.finished ? '' : <Typography style={{clear:'both', float:'left', marginTop: 3, marginLeft: 20}} variant='caption'>Please wait...</Typography>;
}

export default function Chatbox(props) {
  const classes = useStyles();

  return (
    <div className={classes.chatbox}>
      {renderHeader(props)}
      <MessageList {...props} />
      { props.blockSends ? renderBlockedMessage(props) : <Footer {...props} /> }
    </div>
    );
}


